/** Mouse dragging complements native touch/trackpad scrolling, including over a hover portal. */
export function beginCarouselDrag(event: PointerEvent, row: HTMLElement, onDrag?: () => void) {
	if (event.pointerType !== "mouse" || event.button !== 0 || row.scrollWidth <= row.clientWidth + 1) return;
	const startX = event.clientX, startY = event.clientY, startLeft = row.scrollLeft;
	let dragging = false;
	const suppressClick = (click: MouseEvent) => { click.preventDefault(); click.stopImmediatePropagation(); };
	const move = (next: PointerEvent) => {
		if (next.pointerId !== event.pointerId) return;
		const dx = next.clientX - startX;
		if (!dragging) {
			if (Math.abs(dx) < 6 || Math.abs(dx) < Math.abs(next.clientY - startY)) return;
			dragging = true;
			row.setPointerCapture(event.pointerId);
			row.dataset.dragging = "true";
			window.addEventListener("click", suppressClick, true);
			onDrag?.();
		}
		next.preventDefault();
		row.scrollLeft = startLeft - dx;
	};
	const finish = () => {
		window.removeEventListener("pointermove", move);
		window.removeEventListener("pointerup", finish);
		window.removeEventListener("pointercancel", finish);
		window.removeEventListener("blur", finish);
		delete row.dataset.dragging;
		if (row.hasPointerCapture(event.pointerId)) row.releasePointerCapture(event.pointerId);
		// The click generated by pointerup follows this handler in the same gesture.
		setTimeout(() => window.removeEventListener("click", suppressClick, true), 0);
	};
	window.addEventListener("pointermove", move, { passive: false });
	window.addEventListener("pointerup", finish);
	window.addEventListener("pointercancel", finish);
	window.addEventListener("blur", finish);
}
